import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;

  &.align_center {
    align-items: center;
  }

  &.position_left {
    flex-direction: row-reverse;
  }

  &.no-gutters {
    margin-right: 0;
    margin-left: 0;
  }

  &.position_right {
    flex-direction: row;
  }

  &.right {
    flex-direction: row-reverse;
  }
`;
